import { render } from "./HeaderAccount.vue?vue&type=template&id=4410837b&scoped=true"
import script from "./HeaderAccount.vue?vue&type=script&lang=js"
export * from "./HeaderAccount.vue?vue&type=script&lang=js"

import "./HeaderAccount.vue?vue&type=style&index=0&id=4410837b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4410837b"]])

export default __exports__